export const managerMisc = {
  // Shared field / label strings reused across the advisor and user views
  fields: {
    name: "First name",
    lastname: "Last name",
    email: "Email address",
    idNumber: "ID number",
    phone: "Phone",
  },
  // src/views/Manager/pagos/index.vue
  pagos: {
    title: "Payment invoices",
    subtitle: "List of payments made by users",
    emailUser: "User email",
    value: "Amount",
    issueDate: "Issue date",
    status: "Status",
    downloadInvoice: "Download invoice",
    generatingInvoice: "Generating invoice ...",
    almostDone: "Almost done, please wait ...",
    loading: "Loading ...",
    invoiceError: "Sorry, the invoice could not be generated",
  },
  // src/views/Manager/advisors/* and src/components/manager/advisors/*
  advisors: {
    title: "Platform advisors",
    subtitle: "List of advisors.",
    createNew: "Create new",
    thId: "ID",
    thRefCode: "Ref. code",
    thEmail: "Email",
    thRegisterDate: "Registration date",
    deleteConfirmMsg: "Are you sure you want to delete this advisor?",
    deleteConfirmHeader: "Confirm",
    menuUpdateInfo: "Update information",
    menuAffiliatesList: "Affiliates list",
    menuDelete: "Delete",
    createTitle: "Create new advisor",
    savingInfo: "Saving information...",
    saveAdvisor: "Save advisor",
    updateTitle: "Update advisor details",
    updatingInfo: "Updating information...",
    updateAdvisor: "Update advisor",
    cancel: "Cancel",
  },
  // src/components/manager/advisors/modalListAffiliates.vue
  affiliates: {
    listTitle: "Affiliates list",
    emptyPre: "No users are affiliated with the code",
  },
  // src/components/manager/users/menuRoutes.vue
  menu: {
    checkinsDone: "Completed check-ins",
    checkinsPending: "Pending check-ins",
    checkinsScheduled: "Scheduled check-ins",
    logoAndName: "Accommodation logo and name",
    welcomeMessage: "Welcome message",
    policies: "Accommodation policies",
    roomKeys: "Room keys",
    authorities: "Authorities",
    guestReviews: "Guest reviews",
  },
  // src/components/manager/users/accommodations.vue
  accommodations: {
    createdDate: "Creation date",
    checkins: "Check-ins",
  },
  // src/views/Manager/index.vue
  dashboard: {
    title: "Admin panel",
    subtitle: "List of platform statistics",
    registeredUsers: "Registered users",
    viewList: "View list",
    propertiesCreated: "Properties created",
    checkinsDone: "Completed check-ins",
  },
};
